function Autocompletion (input, events) {
    const result = document.getElementById(input.getAttribute('aria-owns'));
    const live = document.createElement('div');
    live.setAttribute('aria-live', "polite");
    live.setAttribute('role', "status");
    live.className = "sr-only";
    result.insertAdjacentElement('afterend', live)

    let timeout = null;
    let value;
    let focusables = [];
    let inc = -1;
    let regex;
    let minCaracters = 1;
    let datas = [];
    let isOpen = false;
    let hasEntry = false;
    let already_used = false;

    this.update = (arr) => {
        datas = arr;
    }

    input.onclick = e => e.stopPropagation();

    const close = () => {
        isOpen = false;
        result.classList.remove('open');
        input.setAttribute('aria-expanded', false);
        document.removeEventListener('keydown', keydown);
        document.removeEventListener('keydown', focus);
        events.onclose(value, hasEntry, already_used);
    }

    const open = () => {
        isOpen = true;
        inc = -1;
        result.classList.add('open');
        input.setAttribute('aria-expanded', true);
        document.addEventListener('keydown', keydown);
        document.addEventListener("click", close, { once: true });
    }

    const filter = () => {
        console.log("filter");
        
        regex = new RegExp(value, "gi");
        let num = 0;
        let markup = `<ul>`;
        for (let item of datas) {
            if (regex.test(item.label)) {
                num++;
                markup += `<li><button type="button" data-used="${item.already_used}" value="${item.code_api}">${item.label.replace(regex, '<b>$&</b>')}</button></li>`;
            }
        }
        markup += `</ul>`;
if(num>0) hasEntry = true;
else hasEntry = false;
        result.innerHTML = markup;

        const btns = result.querySelectorAll('[type="button"]');
        btns.forEach(btn => {
            btn.onclick = () => {
                hasEntry = true;
                already_used = btn.dataset.used;
                input.value = btn.innerText;
                const end = input.value.length;
                input.setSelectionRange(end, end);
                input.focus();
                events.onselect(btn.value);
            }
        })

        focusables = result.querySelectorAll('input, a, [type="button"]');
        if (num > 0) open();
        live.innerHTML = `${num} résultats`;
    }

    const keydown = e => {
        if (e.key === 'Tab') {
            e.preventDefault();
            close();
        }
        if (e.key === 'Escape') {
            input.focus();
            close();
        }
    }

    const focus = e => {
        if (value.length > minCaracters) {
            if (e.key === 'ArrowDown') inc++;
            if (e.key === 'ArrowUp') inc--;
            if (e.key === 'Enter') inc = 0;
            if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
                e.preventDefault();
                if (inc < 0) inc = focusables.length - 1;
                if (inc > focusables.length - 1) inc = 0;
                focusables[inc].focus();
            }
        }
    }

    input.onblur = () => {
       if(!isOpen) events.onblur(value, hasEntry, already_used);
    }

    input.onfocus = () => {
        document.addEventListener('keydown', focus);
        value = input.value.toLowerCase();
        if(value.length > minCaracters) filter();
    }

    input.oninput = () => {hasEntry = false
        document.addEventListener('keydown', focus);
        timeout && clearTimeout(timeout);
        value = input.value.toLowerCase();
       // timeout = setTimeout(() => value.length > minCaracters ? filter() : close(), 200);
        timeout = setTimeout(() => {if(value.length > minCaracters) filter()}, 200);
    }
}

export default Autocompletion ;